import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../useAuth";
import { endpoints, getPath } from "./apiUtils";

export const useUserEvents = (limit) => {
  const { user, getAccessToken } = useContext(AuthContext);
  const path = getPath({
    endpoint: endpoints.events,
    path: [user?.UserId],
    queryParameters: { limit: limit },
  });

  return useQuery(
    ["userEvents", user?.UserId],
    async () =>
      axios
        .get(path, { headers: { Authorization: await getAccessToken() } })
        .then((r) => r.data),
    { enabled: !!user }
  );
};
